import { useState, useEffect } from "react";
import { getAccountSignupsAsync } from "./../../../services/dashboardService";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import SelectListbox from "../../../components/common/SelectListbox";
import moment from "moment";

const frequencies = [
  { name: "Daily", value: 1 },
  { name: "Weekly", value: 2 },
  { name: "Monthly", value: 3 },
];

const AccountSignups = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedFrequency, setSelectedFrequency] = useState(frequencies[2]);
  const [dateRange, setDateRange] = useState({
    start_date: moment().subtract(6, "months").format("MM-DD-yyyy"),
    end_date: moment().format("MM-DD-yyyy"),
  });

  useEffect(() => {
    let mounted = true;

    const fetchData = async () => {
      const { value } = selectedFrequency;
      const { start_date, end_date } = dateRange;

      const { result } = await getAccountSignupsAsync(
        value,
        start_date,
        end_date
      );

      if (mounted) {
        const items = result.map((item) => {
          if (item.frequency === 1) {
            item["name"] = moment(item.start_date).format("DD-MMM-yyyy");
          } else if (item.frequency === 2) {
            item["name"] =
              moment(item.start_date).format("MMM DD") +
              " to " +
              moment(item.end_date).format("MMM DD yyyy");
          } else {
            item["name"] = moment(item.start_date).format("MMM yyyy");
          }

          item["Count"] = item.total_count;
          return item;
        });

        setData(items);
        setIsLoading(false);
      }
    };

    fetchData();

    return () => {
      mounted = false;
    };
  }, [selectedFrequency, dateRange]);

  const handleSelectListChange = (frequency) => {
    setSelectedFrequency(frequency);

    const range = { ...dateRange };

    if (frequency.value === 1) {
      range["start_date"] = moment().subtract(6, "days").format("MM-DD-yyyy");
    } else if (frequency.value === 2) {
      range["start_date"] = moment().subtract(6, "weeks").format("MM-DD-yyyy");
    } else {
      range["start_date"] = moment().subtract(6, "months").format("MM-DD-yyyy");
    }

    setDateRange(range);
  };

  return (
    <div className="card p-0">
      <div className="flex justify-between items-center p-6">
        <p className="text-gray-500">Account Signups</p>
        <SelectListbox items={frequencies} onChange={handleSelectListChange} />
      </div>
      {isLoading && (
        <div className="flex justify-center items-center space-x-1 h-64">
          <div className="bg-blue-400 w-2 h-2 full rounded-full animate-bounce blue-circle"></div>
          <div className="bg-blue-400 w-2 h-2 full rounded-full animate-bounce blue-circle"></div>
          <div className="bg-blue-400 w-2 h-2 full rounded-full animate-bounce blue-circle"></div>
        </div>
      )}
      {!isLoading && (
        <ResponsiveContainer width="100%" height={248}>
          <AreaChart
            width={500}
            height={400}
            data={data}
            margin={{
              top: 5,
              right: 40,
              left: 0,
              bottom: 20,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey="name"
              strokeWidth={0.6}
              axisLine={false}
              tickMargin={10}
              tickLine={false}
              tickSize={5}
              tick={{ fill: "#9ca3af", fontSize: "0.875rem" }}
            />
            <YAxis
              allowDecimals={false}
              axisLine={false}
              tickMargin={15}
              tickLine={false}
              tickSize={5}
              tick={{ fill: "#9ca3af", fontSize: "0.875rem" }}
            />
            <Tooltip />
            <Area
              type="monotone"
              fillOpacity={0.5}
              dataKey="Count"
              stroke="#60a5fa"
              strokeWidth={1.5}
              fill="#60a5fa"
            />
          </AreaChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default AccountSignups;
